export default __webpack_public_path__ + "static/media/info01_Validacion_de_correo.de1b0a3e.png";